export enum TipoIdentificacionEnum {
    CedulaCiudadania = 1,
    Nit = 2,
    RegistroCivil = 3,
    CedulaExtranjeria = 4,
    TarjetaIdentidad = 5,
    Otro = 6
}